import { Card, CardContent, Typography, Box, Stack } from '@mui/material';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { UserOffboardingInfoDto } from '../../../api/userManagementApi';

interface UserOffboardingCardProps {
  offboardingInfo: UserOffboardingInfoDto;
  formatDateTime: (dateString: string) => string;
}

export function UserOffboardingCard({
  offboardingInfo,
  formatDateTime,
}: UserOffboardingCardProps) {
  return (
    <Card variant="outlined" data-testid="user-offboarding-card">
      <CardContent>
        <Stack spacing={2}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <ExitToAppIcon fontSize="small" color="action" />
            <Typography variant="h6" component="h3">
              Offboarding
            </Typography>
          </Box>

          <Stack spacing={1}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant="body2" color="text.secondary">
                Started By
              </Typography>
              <Typography variant="body2" fontWeight={500}>
                {offboardingInfo.startedBy}
              </Typography>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant="body2" color="text.secondary">
                Started At
              </Typography>
              <Typography variant="body2" fontWeight={500}>
                {formatDateTime(offboardingInfo.startedAt)}
              </Typography>
            </Box>

            {offboardingInfo.completedBy && (
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="body2" color="text.secondary">
                  Completed By
                </Typography>
                <Typography variant="body2" fontWeight={500}>
                  {offboardingInfo.completedBy}
                </Typography>
              </Box>
            )}

            {offboardingInfo.completedAt && (
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="body2" color="text.secondary">
                  Completed At
                </Typography>
                <Typography variant="body2" fontWeight={500}>
                  {formatDateTime(offboardingInfo.completedAt)}
                </Typography>
              </Box>
            )}
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
